import {Component, Inject, Prop, Vue} from "vue-property-decorator";
import {MainContainer} from "~/components/main-container";

import grapesjs from "grapesjs";
import {initStorage} from "~/modules/homepage/editor/storage-manager";
import {AppSettings} from "~/lib/app-settings";
import 'grapesjs-preset-webpage';
import {initializeHomePage} from "~/modules/homepage/service";
import {PageTitle} from "~/components/page-title";
import {icons} from "~/components/icon";
import {Columns} from "~/components/grid/columns";
import {Column} from "~/components/grid/column";
import {Label} from "~/components/forms/label";
import {XInput} from "~/components/forms/x-input";
import {className} from "~/lib/helpers/string";
import {Getter} from "vuex-class";

@Component
export class HomePageEdit extends Vue {

  @Getter session;
  @Inject() appSettings: AppSettings;

  protected saving: boolean = false;
  protected loading: boolean = false;
  protected homepageLabel: string = null;

  get inputUUID() {
    return this.$route.params.uuid;
  }

  get isCreateMode() {
    return this.inputUUID === "new";
  }

  async create(){

    if( ! this.session.functionalities?.allowHomepageEdition ){
      return this.$router.push({name: "home"});
    }

    try {
      this.saving = true;
      let homepage = await initializeHomePage(this.appSettings.clientUUID, this.homepageLabel);
      this.$router.push({name: "homepages-edit", params: {uuid: homepage.uuid}});
    } catch(err){
      console.error(err);
    }
    this.saving = false;
  }

  renderNewForm(){
    return (
      <div>
        <h2 class="page-subtitle">Création d'une page</h2>
        <Columns>
          <Column>
            <Label text="Libellé de la page *"/>
            <XInput v-model={this.homepageLabel} />
          </Column>
        </Columns>
        <button
          class={className("button is-primary", {isLoading: this.saving})}
          // disabled={this.isValid === false}
          onClick={this.create}>
          Créer la page
        </button>
      </div>
    );
  }

  render() {

    if( this.isCreateMode) {
      return (
        <MainContainer>
          <PageTitle icon={icons.user} title="Pages d'accueil"/>
          <div class="page-content">
            {this.renderNewForm()}
          </div>
        </MainContainer>
      );
    }

    return <MainContainer class="full-width">
      <div class="page-content">
        <HomePageEditor homePageUUID={this.inputUUID} />
      </div>
    </MainContainer>
  }

}


@Component
class HomePageEditor extends Vue {

  @Prop({type:String, required:true}) homePageUUID:string;

  @Inject() appSettings: AppSettings;
  private editorInstance = null;

  async mounted(){

    this.editorInstance = grapesjs.init({
      container: "#gjs",
      fromElement: true,
      styleManager: { },
      allowScripts: 1,
      storageManager: {
        id:"",                  // Deactivate payload namespacing
        type: "custom-remote",
        autosave: true,         // Store data automatically
        autoload: false,         // Autoload stored data on init
        stepsBeforeSave: 1,     // If autosave enabled, indicates how many changes are necessary before store method is triggered
        storeComponents: true,  // Enable/Disable storing of components in JSON format
        storeStyles: true,      // Enable/Disable storing of rules in JSON format
        storeHtml: true,        // Enable/Disable storing of components as HTML string
        storeCss: true,         // Enable/Disable storing of rules as CSS string
      },
      plugins: ["gjs-preset-webpage"],
      pluginsOpts: {
        "gjs-preset-webpage": {
          blocksBasicOpts: {
            flexGrid: true,
          },
          countdownOpts: false,
          formsOpts: false,
          exportOpts: false,
          navbarOpts:false,
          filestackOpts:false,
          aviaryOpts:false
        }
      }
    });

    this.editorInstance.Panels.addButton('options', [{
        id: 'save-db',
        className: 'fa fa-floppy-o',
        command: 'save-db',
        attributes: {title: 'Save DB'}
      }]
    );

    this.editorInstance.Commands.add('save-db', {
      run: function (editor, sender) {
        sender && sender.set('active', 0); // turn off the button
        editor.store();
      }
    });

    initStorage(this.editorInstance, this.homePageUUID);
    await this.editorInstance.load();
  }

  render(){
    return <div id="gjs" />;
  }

}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-b33c581a/homepage-edit.tsx" });